import React, { useRef, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Microphone, Stop, CircleNotch } from "@phosphor-icons/react";

// Tap to record, tap again to stop — speech is transcribed and passed to onText
export const MicButton = ({ onText, testid = "mic-button", className = "" }) => {
  const [state, setState] = useState("idle");
  const rec = useRef(null);
  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream);
      const chunks = [];
      mr.ondataavailable = (e) => chunks.push(e.data);
      mr.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        setState("busy");
        try {
          const fd = new FormData();
          fd.append("file", new Blob(chunks, { type: mr.mimeType || "audio/webm" }), "voice.webm");
          const { data } = await api.post("/transcribe", fd, { headers: { "Content-Type": "multipart/form-data" } });
          if (data.text) onText(data.text);
        } catch (e) { toast.error("Couldn't turn that into text — please try again"); }
        setState("idle");
      };
      mr.start();
      rec.current = mr;
      setState("rec");
    } catch (e) { toast.error("Microphone not available — allow microphone access"); }
  };
  const click = () => (state === "rec" ? rec.current?.stop() : state === "idle" && start());
  return (
    <button type="button" onClick={click} title={state === "rec" ? "Stop recording" : "Speak instead of typing"}
      className={`h-11 w-11 shrink-0 inline-flex items-center justify-center border ${state === "rec" ? "bg-red-600 text-white border-red-600 animate-pulse" : "border-border text-brand-navy hover:bg-secondary"} ${className}`} data-testid={testid}>
      {state === "busy" ? <CircleNotch size={20} className="animate-spin" /> : state === "rec" ? <Stop size={20} weight="fill" /> : <Microphone size={20} />}
    </button>
  );
};
